<template>
  <v-card class="px-4" elevation="0">
    <v-divider class="grey my-2"></v-divider>
    <v-row no-gutters class="text-center subtitle-1">
      <v-col cols="11" class="font-weight-bold">
        <span class="pl-md-16 pl-6">Список зданий</span>
      </v-col>
      <v-col cols="1" class="font-weight-bold">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                v-bind="attrs"
                v-on="on"
                color="black"
                class="ma-0 pa-0"
                @click="newPostBuilding"
            >
              add
            </v-icon>
          </template>
          <span>Добавить здание</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider class="grey my-2"></v-divider>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-0 pb-2"
    >
      <template v-slot:item.name="{ item }">
        <span>{{ item.building.name }}</span>
      </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  class="mr-2"
                  @click="editGuardPostBuilding(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  @click="deleteGuardPostBuilding(item)"
                  v-bind="attrs"
                  v-on="on"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :guard-building-data="guard_building_data"
        :post="post"
        @close="closeEditDialog"
    ></EditDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить здание ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import EditDialog from "@/modules/admin/guardposts/components/GuardPostDetailBuildingEditDialog";
import ApplyDialog from "@/modules/core/components/ApplyDialog";


export default {
  name: "GuardPostDetailBuildingList",
  props:["post"],
  mixins:[PaginatedDataMapperMixin],
  components: {EditDialog, ApplyDialog},
  data() {
    return {
      headers: [
        {text: "Наименование", value: "name", sortable: false, align: "start", width: "80%"},
        {text: "Действия", value: "actions", sortable: false, align: "center", width: "20%"}
      ],
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      guard_building_data: undefined
    }
  },
  computed: {
    ...mapGetters({
      items: "admin/getGuardBuilding",
      count: "admin/getGuardBuildingCount",
      isLoading: "admin/isLoadingGuardBuilding"
    })
  },
  methods: {
    ...mapActions({
      loadGuardBuildingList: "admin/loadGuardBuildingList",
      deleteGuardBuilding: "admin/deleteGuardBuilding"
    }),
    loadData(url = undefined) {
      this.loadGuardBuildingList({
        url: url,
        post_id: this.post.id,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newPostBuilding() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.guard_building_data = undefined
    },
    editGuardPostBuilding(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.guard_building_data = item
    },
    deleteGuardPostBuilding(item) {
      this.dialog_delete = true
      this.guard_building_data = item
    },
    closeEditDialog() {
      this.loadData()
      this.dialog_add_edit = false
      this.edit_status = undefined
      this.guard_building_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteGuardBuilding({
          post_id: this.post.id,
          id: this.guard_building_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.guard_posts_data = undefined
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
